import type {PageRouteConfig} from '@router';

import ProductList from 'modules/Products/List/ProductList';

export function createProductsListRoute(): PageRouteConfig {
  return {
    element: <ProductList />,
    layout: {
      title: 'لیست محصولات',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
